import { ReactNode } from 'react';

import { useAppSelector } from '../app/hooks';
import { appContextSelector } from '../app/main-slice';

import styles from './buttons.module.css'
import { download, printURL } from '../util/download-print';

export const buttonStyle = styles.button;
export const buttonDisabledStyle = styles.buttonDisabled;

export function ButtonBar({ className, size, children, fill }: {
    className?: string
    size?: 'small' | 'medium' | 'large'
    fill?: boolean
    children?: React.ReactNode
}) {

    const classNames = [ styles.buttonBar ];
    if(className) {
        classNames.push(className);
    }
    if(size === 'large') {
        classNames.push(styles.large);
    }
    if(fill) {
        classNames.push(styles.fill);
    }

    return <div className={classNames.join(' ')}>
        { children }
    </div>
}

export function ButtonList({ className, children }: {
    className?: string
    children?: React.ReactNode
}) {

    const classNames = [ styles.buttonList ];
    if(className) {
        classNames.push(className);
    }

    return <ul className={classNames.join(' ')}>
        { children }
    </ul>
}

export function DownloadButton({ url, extension, mimeType, suggestedName, disabled, centered, children }: {    
    url?: string
    extension: string
    mimeType: string
    suggestedName?: string
    disabled?: boolean
    centered?: boolean
    children?: ReactNode
}) {

    const context = useAppSelector(appContextSelector);
    const isDisabled = disabled || url === undefined;

    const style = `${buttonStyle} ${isDisabled ? buttonDisabledStyle : ''} ${centered ? styles.buttonCentered : ''}`;

    const onDownload = () => {
        if(url) {
            download(url, extension, mimeType, suggestedName);
        }
    }

    if(context === 'stapp') {
        return <a href={url} className={style}>{ children }</a>
    } else {
        return <button className={style} onClick={onDownload} disabled={disabled}>{ children }</button>
    }

}

export function PrintButton({ url, disabled, centered, children }: {    
    url?: string
    disabled?: boolean
    centered?: boolean
    children?: ReactNode
}) {

    const context = useAppSelector(appContextSelector);
    const isDisabled = (disabled ?? false) || url === undefined;

    const style = `${buttonStyle} ${isDisabled ? buttonDisabledStyle : ''} ${centered ? styles.buttonCentered : ''}`;

    const onPrint = () => {
        if(url) {
            printURL(url);
        }
    }

    if(context === 'stapp') {
        return <a href={url} className={style}>{ children }</a>
    } else {
        return <button className={style} onClick={onPrint} disabled={disabled}>{ children }</button>
    }

}